import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { baseurladdress } from "../baseurl";
import * as XLSX from "xlsx-js-style";
const AttendanceReportPage = () => {
    const [selectedBranch, setSelectedBranch] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [branch, setBranch] = useState([]);
    const accesstoken = localStorage.getItem("token");
    const [reportType, setReportType] = useState("summary");
    const [reportData, setReportData] = useState([]);
    const [search, setSearch] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    useEffect(() => {
        const getallbranchesforreport = () => {
            axios.get(baseurladdress + `getallbranchestype`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    setBranch(data);
                })
                .catch(error => {
                    alert(error);
                });
        };
        getallbranchesforreport();
    }, []);

    useEffect(() => {
        const fetchAttendanceReport = () => {
            if (selectedBranch && selectedMonth) {
                axios
                    .get(baseurladdress + `attendance/report`, {
                        params: {
                            branch_id: selectedBranch,
                            month: selectedMonth,
                            type: reportType,
                        },
                        headers: { Authorization: `Bearer ${accesstoken}` },
                    })
                    .then((res) => {
                        const data = res.data.response;
                        setReportData(data);
                    })
                    .catch((error) => {
                        console.error("Fetch error:", error?.response || error?.message || error);
                        alert("Failed to fetch attendance report: " + (error?.message || "Unknown error"));
                    });
            }
        };

        fetchAttendanceReport();
    }, [selectedBranch, selectedMonth, reportType]);

    const filteredData = reportData.filter(item =>
        item.attendance_empname?.toLowerCase().includes(search.toLowerCase())
    );

    const sortedData = [...filteredData].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];
        if (typeof aValue === "string") aValue = aValue.toLowerCase();
        if (typeof bValue === "string") bValue = bValue.toLowerCase();

        if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const requestSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };
    const statusMap = {
        A: { label: "Absent", color: "red" },
        P: { label: "Present", color: "green" },
        H: { label: "Holiday", color: "orange" },
        L: { label: "Leave", color: "purple" },
        I: { label: "Intershift", color: "blue" },
    };
    const StatusBox = ({ letter, color }) => (
        <span style={{
            background: color,
            color: "white",
            width: "24px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "9px",
            fontWeight: "bold"
        }}>
            {letter}
        </span>
    );

    const generateMonthDates = (month) => {
        if (!month) return [];
        const [year, monthNum] = month.split("-").map(Number);
        const daysInMonth = new Date(year, monthNum, 0).getDate();
        return Array.from({ length: daysInMonth }, (_, i) =>
            new Date(year, monthNum - 1, i + 1).toLocaleDateString("en-CA")
        );
    };
    const monthDates = generateMonthDates(selectedMonth);

    const handleExport = () => {
        if (!sortedData || sortedData.length === 0) {
            alert("No data available to export");
            return;
        }

        const offsetMs = 5.5 * 60 * 60 * 1000;
        const DAY_MS = 24 * 60 * 60 * 1000;

        const parseMaybeMs = (val, attendanceDate) => {
            if (val === null || val === undefined || val === "") return NaN;
            if (typeof val === "number") return val;

            let parsed = Date.parse(val);
            if (!isNaN(parsed)) return parsed;

            if (attendanceDate) {
                parsed = Date.parse(`${attendanceDate} ${val}`);
                if (!isNaN(parsed)) return parsed;
            }

            const m = String(val).trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)?$/i);
            if (m) {
                let hh = parseInt(m[1], 10);
                const mm = parseInt(m[2], 10);
                const ss = m[3] ? parseInt(m[3], 10) : 0;
                const ampm = m[4];
                if (ampm) {
                    if (ampm.toLowerCase() === "pm" && hh < 12) hh += 12;
                    if (ampm.toLowerCase() === "am" && hh === 12) hh = 0;
                }
                if (attendanceDate && /^\d{4}-\d{2}-\d{2}$/.test(attendanceDate)) {
                    const [y, mo, d] = attendanceDate.split("-").map(Number);
                    return new Date(y, mo - 1, d, hh, mm, ss).getTime();
                } else {
                    const now = new Date();
                    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hh, mm, ss).getTime();
                }
            }
            return NaN;
        };

        const toDisplayMs = (raw, attendanceDate) => {
            const parsedMs = parseMaybeMs(raw, attendanceDate);
            if (isNaN(parsedMs)) return null;
            return parsedMs + offsetMs;
        };

       
        if (reportType === "summary") {
            const grouped = sortedData.reduce((acc, item) => {
                const key = item.attendance_empid;
                if (!acc[key]) {
                    acc[key] = {
                        empid: item.attendance_empid,
                        name: item.attendance_empname,
                        branch: item.attendance_branchname || "-",
                        origin_order: item.origin_order,
                        records: {},
                    };
                }
                const dateKey = new Date(item.attendance_date).toLocaleDateString("en-CA");
                acc[key].records[dateKey] = item.status;
                return acc;
            }, {});

            const employees = Object.values(grouped);
            const normalEmps = employees.filter(e => e.origin_order !== 1);
            const intershiftEmps = employees.filter(e => e.origin_order === 1);

            const monthDates = [...new Set(sortedData.map(item =>
                new Date(item.attendance_date).toLocaleDateString("en-CA")
            ))].sort();

            let sheetData = [["Sl.No", "Staff Name", ...monthDates]];
            let merges = [];
            let currentRow = 1;
            let slNo = 1;

            const branchGroups = {};
            normalEmps.forEach(emp => {
                if (!branchGroups[emp.branch]) branchGroups[emp.branch] = { normal: [], intershift: [] };
                branchGroups[emp.branch].normal.push(emp);
            });
            intershiftEmps.forEach(emp => {
                if (!branchGroups[emp.branch]) branchGroups[emp.branch] = { normal: [], intershift: [] };
                branchGroups[emp.branch].intershift.push(emp);
            });

            for (const [branchName, { normal, intershift }] of Object.entries(branchGroups)) {
                sheetData.push([branchName]);
                merges.push({
                    s: { r: currentRow, c: 0 },
                    e: { r: currentRow, c: monthDates.length + 1 },
                });
                currentRow++;

                normal.forEach(emp => {
                    sheetData.push([
                        slNo++,
                        emp.name,
                        ...monthDates.map(date => emp.records[date] || "-"),
                    ]);
                    currentRow++;
                });

                if (intershift.length > 0) {
                    sheetData.push(["Intershift Employees"]);
                    merges.push({
                        s: { r: currentRow, c: 0 },
                        e: { r: currentRow, c: monthDates.length + 1 },
                    });
                    currentRow++;

                    intershift.forEach(emp => {
                        sheetData.push([
                            slNo++,
                            emp.name,
                            ...monthDates.map(date => emp.records[date] || "-"),
                        ]);
                        currentRow++;
                    });
                }

                sheetData.push([]);
                currentRow++;
            }

            const ws = XLSX.utils.aoa_to_sheet(sheetData);
            ws["!merges"] = merges;
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Summary Report");
            XLSX.writeFile(wb, "Summary_Report.xlsx");
            return;
        }

      
        const groupedByBranch = sortedData.reduce((acc, item) => {
            const branch = item.attendance_branchname || "-";
            if (!acc[branch]) acc[branch] = { normal: [], intershift: [] };
            if (item.origin_order === 1) acc[branch].intershift.push(item);
            else acc[branch].normal.push(item);
            return acc;
        }, {});

        const sheetData = [["Sl.No", "Staff Name", "Date", "Punch In", "Punch Out", "Admin In", "Admin Out", "Working Hours"]];
        const merges = [];
        let currentRow = 1;
        let slNo = 1;

        for (const [branchName, { normal, intershift }] of Object.entries(groupedByBranch)) {
            
            sheetData.push([branchName]);
            merges.push({
                s: { r: currentRow, c: 0 },
                e: { r: currentRow, c: 7 },
            });
            currentRow++;

            const addEmployeeData = (dataList) => {
                dataList.forEach((item, idx) => {
                    const punchInDisplayMs = item.punchin_time ? toDisplayMs(item.punchin_time, item.attendance_date) : null;
                    const punchOutDisplayMs = item.punchout_time ? toDisplayMs(item.punchout_time, item.attendance_date) : null;
                    const adminInDisplayMs = item.adminmarked_in ? toDisplayMs(item.adminmarked_in, item.attendance_date) : null;
                    const adminOutDisplayMs = item.adminmarked_out ? toDisplayMs(item.adminmarked_out, item.attendance_date) : null;

                    const inDisplayMs = adminInDisplayMs || punchInDisplayMs;
                    const outDisplayMs = adminOutDisplayMs || punchOutDisplayMs;

                    const formatTime = (ms) =>
                        ms
                            ? new Date(ms).toLocaleTimeString("en-IN", {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                            })
                            : "-";

                    const punchInStr = formatTime(punchInDisplayMs);
                    const punchOutStr = formatTime(punchOutDisplayMs);
                    const adminInStr = formatTime(adminInDisplayMs);
                    const adminOutStr = formatTime(adminOutDisplayMs);

                    let workingHoursStr = "-";
                    if (inDisplayMs && outDisplayMs) {
                        let diffMs = outDisplayMs - inDisplayMs;
                        if (diffMs <= 0 || diffMs > DAY_MS) {
                            const inDay = inDisplayMs % DAY_MS;
                            const outDay = outDisplayMs % DAY_MS;
                            diffMs = (outDay - inDay + DAY_MS) % DAY_MS;
                        }
                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
                        workingHoursStr = `${hours}h ${minutes}m ${seconds}s`;
                    }

                    sheetData.push([
                        slNo++,
                        item.attendance_empname,
                        new Date(item.attendance_date).toLocaleDateString("en-CA"),
                        punchInStr,
                        punchOutStr,
                        adminInStr,
                        adminOutStr,
                        workingHoursStr,
                    ]);
                    currentRow++;
                });
            };

          
            addEmployeeData(normal);

           
            if (intershift.length > 0) {
                sheetData.push(["Intershift Employees"]);
                merges.push({
                    s: { r: currentRow, c: 0 },
                    e: { r: currentRow, c: 7 },
                });
                currentRow++;
                addEmployeeData(intershift);
            }

           
            sheetData.push([]);
            currentRow++;
        }

        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        ws["!merges"] = merges;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Detailed Report");
        XLSX.writeFile(wb, "Detailed_Report.xlsx");
    };


    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h6 className="card-title">
                                        <i className="fas fa-calendar-check me-2 text-primary"></i>
                                        Punching Report
                                    </h6>
                                </div>

                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-sm-3">
                                            <h6>Branch</h6>
                                            <select
                                                className="form-control"
                                                value={selectedBranch}
                                                onChange={(e) => setSelectedBranch(e.target.value)}
                                            >
                                                <option value="">Choose branch</option>
                                                {reportType === "detailed" && (
                                                    <option value="all">All Branches</option>
                                                )}
                                                {branch.map((item) => (
                                                    <option key={item.branch_id} value={item.branch_id}>
                                                        {item.branch_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-sm-3">
                                            <h6>Month</h6>
                                            <input
                                                type="month"
                                                className="form-control"
                                                value={selectedMonth}
                                                onChange={(e) => setSelectedMonth(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-sm-3">
                                            <h6>Report Type</h6>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="reportType"
                                                    value="summary"
                                                    checked={reportType === "summary"}
                                                    onChange={(e) => setReportType(e.target.value)}
                                                />
                                                <label className="form-check-label">Summary Report</label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="reportType"
                                                    value="detailed"
                                                    checked={reportType === "detailed"}
                                                    onChange={(e) => setReportType(e.target.value)}
                                                />
                                                <label className="form-check-label">Detailed Report</label>
                                            </div>
                                        </div>

                                        <div className="col-sm-2 d-flex align-items-end">
                                            <button
                                                className="btn btn-success w-100"
                                                onClick={handleExport}
                                            >
                                                <i className="fas fa-file-export me-2"></i> Export
                                            </button>
                                        </div>

                                        <div className="mt-2">
                                            <h6> </h6>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by Staff Name"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", gap: "20px", marginBottom: "15px", flexWrap: "wrap" }}>
                                        {Object.entries(statusMap).map(([key, { label, color }]) => (
                                            <div key={key} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <StatusBox letter={key} color={color} />
                                                <span>{label}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="table-responsive mt-3">
                                        {reportType === "summary" ? (
                                            <table className="table table-bordered table-striped" style={{ border: "1px solid #ddd" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "left" }}>Sl.No</th>
                                                        <th style={{ textAlign: "left" }}>Staff Name</th>
                                                        {monthDates.map((date, idx) => (
                                                            <th key={idx}>
                                                                {new Date(date).getDate().toString().padStart(2, "0")}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(() => {
                                                        const grouped = sortedData.reduce((acc, item) => {
                                                            const key = item.attendance_empid;
                                                            if (!acc[key]) {
                                                                acc[key] = {
                                                                    empid: item.attendance_empid,
                                                                    name: item.attendance_empname,
                                                                    origin_order: item.origin_order,
                                                                    records: {},
                                                                };
                                                            }
                                                            const dateKey = new Date(item.attendance_date).toLocaleDateString("en-CA");
                                                            acc[key].records[dateKey] = item.status;
                                                            return acc;
                                                        }, {});

                                                        const employees = Object.values(grouped);
                                                        const normalEmps = employees.filter(e => e.origin_order !== 1);
                                                        const intershiftEmps = employees.filter(e => e.origin_order === 1);

                                                        const renderRow = (emp, idx) => (
                                                            <tr key={idx}>
                                                                <td style={{ textAlign: "left" }}>{idx + 1}</td>
                                                                <td>{emp.name}</td>
                                                                {monthDates.map((date, i) => (
                                                                    <td key={i} style={{ textAlign: "center" }}>
                                                                        {(() => {
                                                                            const statusValue = emp.records[date];
                                                                            if (!statusValue) return "-";

                                                                            if (statusValue.startsWith("L")) {
                                                                                return <StatusBox letter="L" color={statusMap["L"].color} />;
                                                                            }

                                                                            if (statusValue === "Intershift") {
                                                                                return <StatusBox letter="I" color={statusMap["I"].color} />;
                                                                            }

                                                                            const key = statusValue.charAt(0);
                                                                            return statusMap[key] ? (
                                                                                <StatusBox letter={key} color={statusMap[key].color} />
                                                                            ) : "-";
                                                                        })()}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        );

                                                        return (
                                                            <>
                                                                {normalEmps.map((emp, idx) => renderRow(emp, idx))}

                                                                {intershiftEmps.length > 0 && (
                                                                    <>
                                                                        <tr>
                                                                            <td
                                                                                colSpan={monthDates.length + 2}
                                                                                style={{
                                                                                    fontWeight: "bold",
                                                                                    background: "#f0f0f0",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >
                                                                                Intershift Employees
                                                                            </td>
                                                                        </tr>
                                                                        {intershiftEmps.map((emp, idx) => renderRow(emp, normalEmps.length + idx))}
                                                                    </>
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <table className="table table-bordered table-striped" style={{ border: "1px solid #ddd" }}>
                                                <thead >
                                                    <tr>
                                                        <th
                                                            onClick={() => requestSort("attendance_empid")}
                                                            style={{ cursor: "pointer", width: "60px", textAlign: "center" }}
                                                        >
                                                            Sl.No
                                                        </th>
                                                        <th
                                                            onClick={() => requestSort("attendance_empname")}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            Staff Name
                                                        </th>
                                                        <th
                                                            onClick={() => requestSort("attendance_date")}
                                                            style={{ cursor: "pointer", width: "120px", textAlign: "left" }}
                                                        >
                                                            Date
                                                        </th>
                                                        <th style={{ textAlign: "left" }}>Status</th>
                                                        {reportType === "detailed" && (
                                                            <>
                                                                <th>Punch In</th>
                                                                <th style={{ textAlign: "left" }}>Punch Out</th>
                                                                <th>Admin In</th>
                                                                <th style={{ textAlign: "left" }}>Admin Out</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sortedData.length > 0 ? (
                                                        sortedData.map((item, index) => {
                                                            const showName =
                                                                index === 0 ||
                                                                sortedData[index - 1].attendance_empid !== item.attendance_empid;

                                                            const isFirstIntershift =
                                                                item.origin_order === 1 &&
                                                                (index === 0 || sortedData[index - 1].origin_order !== 1);

                                                            const isFirstBranch =
                                                                index === 0 ||
                                                                sortedData[index - 1].attendance_branchid !== item.attendance_branchid;

                                                            return (
                                                                <React.Fragment key={index}>
                                                                    {isFirstBranch && (
                                                                        <tr>
                                                                            <td
                                                                                colSpan={reportType === "detailed" ? 6 : 4}
                                                                                style={{
                                                                                    fontWeight: "bold",
                                                                                    background: "#e8f4ff",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >
                                                                                {item.attendance_branchname}
                                                                            </td>
                                                                        </tr>
                                                                    )}

                                                                    {isFirstIntershift && (
                                                                        <tr>
                                                                            <td
                                                                                colSpan={reportType === "detailed" ? 6 : 4}
                                                                                style={{
                                                                                    fontWeight: "bold",
                                                                                    background: "#f0f0f0",
                                                                                    textAlign: "center"
                                                                                }}
                                                                            >
                                                                                Intershift Employees
                                                                            </td>
                                                                        </tr>
                                                                    )}

                                                                    <tr>
                                                                        <td>{index + 1}</td>
                                                                        <td>{showName ? item.attendance_empname : ""}</td>
                                                                        <td>{new Date(item.attendance_date).toLocaleDateString("en-CA")}</td>
                                                                        <td style={{ textAlign: "left" }}>
                                                                            {item.status?.startsWith("L") ? (
                                                                                <span style={{ display: "inline-flex", alignItems: "center" }}>
                                                                                    <StatusBox letter="L" color={statusMap["L"].color} />
                                                                                    <span style={{ marginLeft: "6px" }}>
                                                                                        - {item.status.split(" - ")[1]}
                                                                                    </span>
                                                                                </span>
                                                                            ) : item.status === "Intershift" ? (
                                                                                <StatusBox letter="I" color={statusMap["I"].color} />
                                                                            ) : (
                                                                                statusMap[item.status?.charAt(0)] && (
                                                                                    <StatusBox
                                                                                        letter={item.status.charAt(0)}
                                                                                        color={statusMap[item.status.charAt(0)].color}
                                                                                    />
                                                                                )
                                                                            )}
                                                                        </td>

                                                                        {reportType === "detailed" && (
                                                                            <>

                                                                                <td>
                                                                                    {item.status === "Intershift"
                                                                                        ? "_"
                                                                                        : item.punchin_time
                                                                                            ? (
                                                                                                <>
                                                                                                    {new Date(
                                                                                                        new Date(item.punchin_time).getTime() + 5.5 * 60 * 60 * 1000
                                                                                                    ).toLocaleTimeString("en-IN", {
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                        second: "2-digit",
                                                                                                        hour12: true,
                                                                                                    })}
                                                                                                    {item.punchin_status && (
                                                                                                        <span style={{ color: "blue", marginLeft: "5px" }}>
                                                                                                            - {item.punchin_status}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </>
                                                                                            )
                                                                                            : "-"}
                                                                                </td>


                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {item.status === "Intershift"
                                                                                        ? "_"
                                                                                        : item.punchout_time
                                                                                            ? (
                                                                                                <>
                                                                                                    {new Date(
                                                                                                        new Date(item.punchout_time).getTime() + 5.5 * 60 * 60 * 1000
                                                                                                    ).toLocaleTimeString("en-IN", {
                                                                                                        hour: "2-digit",
                                                                                                        minute: "2-digit",
                                                                                                        second: "2-digit",
                                                                                                        hour12: true,
                                                                                                    })}
                                                                                                    {item.punchout_status && (
                                                                                                        <span style={{ color: "blue", marginLeft: "5px" }}>
                                                                                                            - {item.punchout_status}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </>
                                                                                            )
                                                                                            : "-"}
                                                                                </td>



                                                                                <td>
                                                                                    {item.adminmarked_in
                                                                                        ? new Date(new Date(item.adminmarked_in).getTime() + 5.5 * 60 * 60 * 1000)
                                                                                            .toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })
                                                                                        : "-"}
                                                                                </td>


                                                                                <td style={{ textAlign: "left" }}>
                                                                                    {item.adminmarked_out
                                                                                        ? new Date(new Date(item.adminmarked_out).getTime() + 5.5 * 60 * 60 * 1000)
                                                                                            .toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })
                                                                                        : "-"}
                                                                                </td>

                                                                            </>
                                                                        )}

                                                                    </tr>
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan={reportType === "detailed" ? 6 : 4}
                                                                className="text-center text-muted"
                                                            >
                                                                No data available.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default AttendanceReportPage;
